import Consultation from "./results";
import Handlebars from 'handlebars/dist/handlebars.min.js';

Consultation.prototype.addDietAndLifestyleBandVariables = function(varDict, scores) {
  // console.log(dietAndLifestyleScores);
  var dp = 0;
  var lp = 0;
  if (typeof scores.lifestyle != "undefined") dp = scores.lifestyle;
  varDict['ScoreLifestyleLessThan51'] = dp < 51;
  varDict['ScoreLifestyle51to75'] = dp >= 51 && dp <= 75;
  varDict['ScoreLifestyle76to85'] = dp >= 76 && dp <= 85;
  varDict['ScoreLifestyle86plus'] = dp >= 86;
  if (typeof scores.lifestyle != "undefined") lp = scores.diet;
  varDict['ScoreDietLessThan51'] = lp <= 50;
  varDict['ScoreDiet51to75'] = lp >= 51 && lp <= 75;
  varDict['ScoreDiet76to85'] = lp >= 76 && lp <= 85;
  varDict['ScoreDiet86plus'] = lp >= 86;
  return varDict;
}

Consultation.prototype.generateReport = function(reportName, reportData) {
// console.log(reportName);
  var sluggedReportName = slugify(reportName);
  // console.log(sluggedReportName);
  // console.log(reportData);
  
  this.reportContentTemplate = Handlebars.compile('{{#> '+sluggedReportName+'}}{{/'+sluggedReportName+'}}');
  this.reportBaseTemplate = Handlebars.compile('{{> base }}');
  var $report_content = this.reportContentTemplate(reportData);
  $report_content = $.trim($report_content.replace(/<p><\/p>/g, ""));
  // console.log($report_content);
  if($report_content) {
    var $raw_html = this.reportBaseTemplate({
      'title': reportName+" Wellness Guide",
      'content': $report_content
    });
    $raw_html = this.dedupeReportHtml($raw_html);
    return $raw_html;
  }
}

Consultation.prototype.processHealthReports = function(varDict, extraData) {
    var that = this;
    var data = jQuery.extend(varDict, extraData);

    Handlebars.registerPartial('base', "{{{content}}}");
    
    jQuery.each(this.reports, function (key,value) {
      key = slugify(key);
      Handlebars.registerPartial(key, value);
    });
    
    return jQuery.map(that.findMatchingReports(varDict, that.reports_truth_table), function(report) {
      var content = that.generateReport(report.report, data);
      if (typeof content != "undefined") {
        return {
          "title": report.report,
          "content": content
        }
      }
    });
}

Consultation.prototype.findMatchingReports = function(varDict, truthTable) {
    var reports = [
        {
          report: 'General Diet',
          priority: 0,
        },
        {
          report: 'General Lifestyle',
          priority: 0,
        }
    ];
    return reports;
}

Consultation.prototype.dedupeReportHtml = function($orig_html) {
  var that = this;
  var $raw_html = $orig_html;
  var re = "/(<span class='content'>.*?<\/span>)/gs";
  var matches = $raw_html.match(re);
  jQuery.each(matches, function(i, v) {
    var first_100_chars_of_para = v.substring(0, 100);
    var re2 = new RegExp(regexEscape(first_100_chars_of_para) + '.*?<\/span>', 'gi');
    $raw_html = that.removeDuplicateRegexMatchesExceptFirst($raw_html, re2);
  });

  re = "/(<li>.*?<\/li>)/gs";
  matches = $raw_html.match(re);
  jQuery.each(matches, function(i, v) {
    var first_100_chars_of_para = v.substring(0, 100);
    var re2 = new RegExp(regexEscape(first_100_chars_of_para) + '.*?<\/li>', 'gi');
    $raw_html = that.removeDuplicateRegexMatchesExceptFirst($raw_html, re2);
  });

  re = "/(<p>.*?<\/p>)/gs";
  matches = $raw_html.match(re);
  jQuery.each(matches, function(i, v) {
    if(v.length > 20) {
      var first_100_chars_of_para = v.substring(0, 100);
      var re2 = new RegExp(regexEscape(first_100_chars_of_para) + '.*?<\/p>', 'gi');
      $raw_html = that.removeDuplicateRegexMatchesExceptFirst($raw_html, re2);
    }
  });

  return $raw_html;
}

Consultation.prototype.removeDuplicateRegexMatchesExceptFirst = function(string, regex) {
  var count = 0
  var replaceWith = '<!-- Dupe Content Deleted -->'
  return string.replace(regex, function (match) {
    count++
    if (count === 1) {
      return match
    } else {
      return replaceWith
    }
  })
}

/**
 * Slugify a string
 * @param {String} text
 * @return {String}
 */
function slugify(text) {
  return text.toString().toLowerCase()
    .replace(/([å,ä])/g, 'a')       // Replace å and ä with aa
    .replace(/(ö)/g, 'o')           // Replace ö with o 
    .replace(/\s+/g, '-')           // Replace spaces with -
    .replace(/[^\w\-]+/g, '')       // Remove all non-word chars
    .replace(/\-\-+/g, '-')         // Replace multiple - with single -
    .replace(/^-+/, '')             // Trim - from start of text
    .replace(/-+$/, '');            // Trim - from end of text
}

function regexEscape(str) {
  return str.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&')
}

export default Consultation;


// WEBPACK FOOTER //
// ./js/components/consultation/reports.js